import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-522e50fb")

_pushScopeId("data-v-522e50fb")
const _hoisted_1 = { class: "ExpressMultiItems" }
const _hoisted_2 = { class: "ExpressMultiItems__title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Цена: ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Не указана")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Удалить ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h2", _hoisted_2, "Добавленные товары (" + _toDisplayString(_ctx.items.length) + ")", 1),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
      return (_openBlock(), _createBlock("div", {
        key: `ExpressMultiItem-${i}`,
        class: "ExpressMultiItems__item"
      }, [
        _createVNode("div", null, [
          _createVNode("p", null, [
            _createVNode("b", null, _toDisplayString(item.title), 1)
          ]),
          _createVNode("p", null, [
            _hoisted_3,
            (item.price)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(item.price) + " тенге", 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_4
                ], 64))
          ]),
          _createVNode("p", null, "Количество: " + _toDisplayString(item.count), 1)
        ]),
        _createVNode(_component_s_button, {
          class: "black",
          disabled: _ctx.disabled,
          onClick: ($event: any) => (_ctx.emitRemoveItem(i))
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 2
        }, 1032, ["disabled", "onClick"])
      ]))
    }), 128))
  ]))
})